import React from 'react'

import TextToTextTransformerLayout from '../../../components/layouts/TextToTextTransformerLayout'
import useLangConfig from '../../../hooks/useLangConfig'
import IndentOptionsSelect from '../../../components/modules/IndentOptionsSelect'


export default function CodeConverterLayout({inputLang, outputLang, convert}) {

  const outputLangConfig = useLangConfig(outputLang)
  const [options, setOptions] = React.useState(outputLangConfig.indent ? {
    useTabs: outputLangConfig.indent.default === 'tab',
    tabWidth: outputLangConfig.indent.default !== 'tab' ? outputLangConfig.indent.default : undefined,
  } : {})
  const onIndentOptionsChange = (indentOptions) => {
    setOptions({...options, ...indentOptions})
  }

  const convertFunc = React.useCallback((textInput) => {
    return convert(textInput, options)
  }, [convert, options])

  return (
    <TextToTextTransformerLayout
      inputLang={inputLang}
      outputLang={outputLang}
      transform={convertFunc}

      inputExtraControl={
        outputLangConfig.indent ? (
          <IndentOptionsSelect
            currentIndentOptions={options}
            onIndentOptionsChange={onIndentOptionsChange}
            supportTab={outputLangConfig.indent.supportTab}
          />
        ) : undefined
      }
    />
  )
}
